export default __webpack_public_path__ + "static/media/arrow_right_white.f5990d17.svg";